import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import _ from 'lodash';

import RaisedButton from 'material-ui/RaisedButton';
import AutoComplete from 'material-ui/AutoComplete';

import styles from 'styles';
import { updateRequestVessel, deleteRequestVessel } from 'actions/vessels/request';
import api from 'services';
import OpenMailBlock from '../../Base/Mails/OpenMailBlock';
import { execute } from 'store/configureStore';
import { saveRequestsDataDeleted } from 'sagas/orders';

class Item extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userEmails: [],
            item: props.item || {},
            name: _.has(props.item, 'addedBy.name') ? props.item.addedBy.name : '',
            surname: _.has(props.item, 'addedBy.surname') ? props.item.addedBy.surname : '',
            email: _.has(props.item, 'addedBy.email') ? props.item.addedBy.email : '',
            id: _.has(props.item, 'addedBy._id') ? props.item.addedBy._id : '',
            vesselRequestId: _.has(props.item, '_id') ? props.item._id : '',
            isUpdate: false,
        };

        this.changeUser = this.changeUser.bind(this);
        this.chooseUser = this.chooseUser.bind(this);
        this.deleteVesselRequest = this.deleteVesselRequest.bind(this);
        this.updateVesselRequest = this.updateVesselRequest.bind(this);
        this.saveRequestsDataDeleted = this.saveRequestsDataDeleted.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            isUpdate: nextProps.item.isUpdate,
            item: nextProps.item,
        });
    }

    saveRequestsDataDeleted = async () => {
        try {
            await execute(saveRequestsDataDeleted, 'vessel', { mailId: this.props.item.mailId });
        } catch (error) {
            console.error(error);
        }
    };

    deleteVesselRequest() {
        this.props.item.mailId && this.saveRequestsDataDeleted();
        this.props.deleteRequestVessel(this.props.item.vessel, this.props.item._id);
    }

    updateVesselRequest() {
        this.setState({
            isUpdate: true,
        }, () => {
            this.props.updateRequestVessel(this.state.vesselRequestId, this.state.id);
        });
    }

    changeUser(searchText) {
        this.setState({
            email: searchText,
            isUpdate: false,
        }, () => {
            api.findUser(searchText)
                .then((response) => {
                    const userEmails = response.data.data.map(user => ({
                        name: `${user.email} - (${user.name || ''} ${user.surname || ''})`,
                        item: user,
                    }));

                    this.setState({
                        userEmails,
                    });
                })
                .catch(() => null);
        });
    }

    chooseUser(updateProperties) {
        if (!updateProperties) {
            return;
        }

        this.setState({
            name: updateProperties.item.name,
            surname: updateProperties.item.surname,
            email: updateProperties.item.email,
            id: updateProperties.item._id,
            isUpdate: true,
        });
    }

    render() {
        const { name, surname, email, userEmails, isUpdate } = this.state;
        const { item } = this.props;

        let autoComplete = (<AutoComplete
            textFieldStyle={styles.autoCompleteCSS}
            hintText='User'
            searchText={email}
            dataSource={userEmails}
            dataSourceConfig={{ text: 'name', value: 'item' }}
            onUpdateInput={this.changeUser}
            onNewRequest={this.chooseUser}
            filter={AutoComplete.noFilter}
            fullWidth
            listStyle={styles.autoCompleteListStyle}
            popoverProps={{
                canAutoPosition: true,
                anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                targetOrigin: { horizontal: 'left', vertical: 'top' },
            }}
        />);

        let managementBlock = (<div className='paper-block'>
            <div className='name-block absolute small-name'>Managment</div>
            <RaisedButton
                onClick={this.deleteVesselRequest}
                label='Delete'
                style={{ margin: '0 10px 0 0' }}
                secondary
            />
            <RaisedButton
                onClick={this.updateVesselRequest}
                disabled={!isUpdate}
                label='Update user'
                style={{ margin: '0 10px 0 0' }}
                primary
            />
        </div>);

        if (item.deleteBy) {
            managementBlock = (<div className='paper-block'>
                <div className='name-block absolute small-name'>Deleted</div>
                <span>Delete at: </span>{moment(item.deleteAt).format('MM-DD-YYYY')}<br />
                <span>Delete by: </span>{_.has(item, 'deleteBy.email') ? item.deleteBy.email : ''}
            </div>);

            autoComplete = (<div><span>Email: </span>{this.state.email}</div>);
        }

        return (
            <div className='paper-block item-request'>
                <div className='col col-4'>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>unique info</div>
                        <span>refNo: </span>{item.refNo}
                    </div>

                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>info</div>
                        <span>name: </span>{item.name}<br />
                        <span>dwt: </span>{item.dwt}<br />
                        <span>imoNumber: </span>{item.imoNumber}<br />
                    </div>
                </div>

                <div className='col col-4'>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>Company</div>
                        <span>Name: </span>{_.has(item, 'addedBy.company.name') ? item.addedBy.company.name : ''}
                    </div>

                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>Open position</div>
                        <span>Name: </span>{item.open.name}<br />
                        <span>From: </span>{moment(item.open.from).startOf('day').toDate().toLocaleDateString()}<br />
                        <span>Until: </span>{moment(item.open.until).startOf('day').toDate().toLocaleDateString()}<br />
                    </div>
                </div>

                <div className='col col-4'>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>User</div>
                        <span>Name: </span>{name}<br />
                        <span>Surname: </span>{surname}<br />
                        {autoComplete}
                    </div>
                    {
                        item.realUser && (
                            <div className='paper-block'>
                                <div className='name-block absolute small-name'>Real user</div>
                                <span>Email: </span>{item.realUser.email}<br />
                            </div>
                        )
                    }
                    {managementBlock}
                    {
                        item.mailId && <OpenMailBlock mailId={item.mailId} />
                    }
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        return {
            item: ownProps.item,
        };
    },
    dispatch => bindActionCreators({ updateRequestVessel, deleteRequestVessel }, dispatch),
)(Item);



// WEBPACK FOOTER //
// ./app/components/Vessels/Requests/Item.jsx